<template>
  <div class="block block--pages">
    <ProductCard
      v-for="product in pages"
      :key="product.id"
      :product="product"
    />
  </div>
</template>

<script lang="ts">
import ProductCard from '@/components/products/ProductCard.vue';
import { SuluDocument } from '@/logic/cms/sulu';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  components: { ProductCard },
  props: {
    pages: {
      type: Array as PropType<SuluDocument[]>,
    },
  },
});
</script>
